import * as React from 'react'
import type {SVGProps} from 'react'
const SvgTrackManageOrder = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        {...props}
    >
        <defs>
            <path id="track-manage-order_svg__a" d="M0 0h20v20H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <mask id="track-manage-order_svg__b" fill="#fff">
                    <use xlinkHref="#track-manage-order_svg__a" />
                </mask>
                <path
                    fill="currentColor"
                    d="M18.5 18c0 .271-.23.5-.5.5H2a.507.507 0 0 1-.5-.5V7c0-.27.229-.5.5-.5h16c.27 0 .5.23.5.5zM4.69 1.737a.51.51 0 0 1 .427-.237H9.25V5H2.659zM14.884 1.5c.172 0 .335.091.43.245L17.34 5h-6.59V1.5h4.133zm4.844 4.511.008-.005-3.15-5.055a2 2 0 0 0-1.702-.95H5.117a2 2 0 0 0-1.703.95L.264 6.006l.009.005c-.17.294-.273.628-.273.99v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-.362-.104-.696-.273-.99z"
                    mask="url(#track-manage-order_svg__b)"
                />
            </g>
            <path
                fill="currentColor"
                d="M8.239 15.166za.94.94 0 0 0 1.331 0l4.126-4.126a.94.94 0 0 0 .275-.666.94.94 0 0 0-.275-.665.96.96 0 0 0-1.331 0l-3.46 3.462-1.27-1.269a.96.96 0 0 0-1.33 0 .93.93 0 0 0-.275.665c0 .251.097.488.275.663z"
            />
        </g>
    </svg>
)
export default SvgTrackManageOrder
